export default "__VITE_ASSET__b7d531fd__"